import React, { useState } from 'react';
import { 
  getFirestore, 
  collection, 
  getDocs, 
  setDoc, 
  doc, 
  serverTimestamp 
} from 'firebase/firestore';
import { authors } from '../../data/authors';
import app from "../../firebase/firebase";

const db = getFirestore(app);

export default function AdminCreateInsuranceBlogPost({ isAuthenticated }) {
  const [showForm, setShowForm] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [content, setContent] = useState(`<p class="text-muted"><span class="dropcaps display-4 text-dark me-2">T</span>he most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. Lorem Ipsum is composed in a pseudo-Latin language which more or less corresponds to 'proper' Latin. It contains a series of real Latin words. This ancient dummy text is also incomprehensible, but it imitates the rhythm of most European languages in Latin script. The advantage of its Latin origin and the relative meaninglessness of Lorum Ipsum is that the text does not attract attention to itself or distract the viewer's attention from the layout.</p>`);  
  // Set category to "Insurance" by default and fix it.
  const [category] = useState('Insurance');
  const [author, setAuthor] = useState('');
  const [headerImageUrl, setHeaderImageUrl] = useState('https://inclusivefamilyinsurance.com/static/media/blog_content/who-we-are-about1.422b19aa700d9bb96a32.jpg');
  const [bottomImageUrl, setBottomImageUrl] = useState('');
  const [readTime, setReadTime] = useState('');
  const [tags, setTags] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Query the "insurance-blog" collection to get the highest current numeric ID.
    const blogRef = collection(db, "insurance-blog");
    const querySnapshot = await getDocs(blogRef);
    let maxId = 0;
    querySnapshot.forEach((docSnap) => {
      const docId = parseInt(docSnap.id, 10);
      if (!isNaN(docId) && docId > maxId) {
        maxId = docId;
      }
    });
    const newId = maxId + 1;

    // Convert comma-separated tags into an array.
    const tagsArray = tags
      .split(',')
      .map((t) => t.trim())
      .filter((t) => t !== '');

    // Build the new post object with the required fields.
    const newPost = {
      author,
      "bottom-image-url": bottomImageUrl,
      category,
      content,
      description,
      "header-image-url": headerImageUrl,
      "read-time": Number(readTime),
      tags: tagsArray,
      timestamp: serverTimestamp(),
      title
    };

    try {
      // Save the new post in "insurance-blog" with a document ID equal to the newId.
      await setDoc(doc(db, "insurance-blog", newId.toString()), newPost);
      alert(`New post created with id ${newId}`);
    } catch (error) {
      console.error("Error creating post: ", error);
      alert("Error creating post, please try again.");
    } finally {
      // Reset form fields and close the form.
      setTitle('');
      setDescription('');
      setContent('');
      setAuthor('');
      setHeaderImageUrl('');
      setBottomImageUrl('');
      setReadTime('');
      setTags('');
      setShowForm(false);
    }
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <div className="admin-create-blog-post my-3">
      {!showForm ? (
        <button
          className="btn btn-primary"
          onClick={() => setShowForm(true)}
        >
          Create New Blog Post
        </button>
      ) : (
        <form onSubmit={handleSubmit} className="p-3 border rounded">
          <h4 className="mb-3">Create a New Insurance Blog Post</h4>

          <div className="mb-3">
            <label className="form-label">Title</label>
            <input
              type="text"
              className="form-control"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter blog post title"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Author</label>
            <select
              className="form-select"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
              required
            >
              <option value="" disabled>Select an author</option>
              {authors.map((auth) => (
                <option key={auth.id} value={auth.name}>
                  {auth.name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Enter blog post description"
              rows={3}
              required
            ></textarea>
          </div>

          <div className="mb-3">
            <label className="form-label">Content</label>
            <textarea
              className="form-control"
              value={content}
              onChange={(e) => setContent(e.target.value)}
              placeholder="Enter blog post content"
              rows={6}
              required
            ></textarea>
          </div>

          <div className="mb-3">
            <label className="form-label">Category</label>
            <input
              type="text"
              className="form-control"
              value={category}
              readOnly
              style={{ backgroundColor: '#e9ecef' }}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Header Image URL (also thumbnail)</label>
            <input
              type="text"
              className="form-control"
              value={headerImageUrl}
              onChange={(e) => setHeaderImageUrl(e.target.value)}
              placeholder="Paste the URL for the header image"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Bottom Image URL (optional)</label>
            <input
              type="text"
              className="form-control"
              value={bottomImageUrl}
              onChange={(e) => setBottomImageUrl(e.target.value)}
              placeholder="Paste the URL for the bottom image"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Read Time (minutes)</label>
            <input
              type="number"
              className="form-control"
              value={readTime}
              onChange={(e) => setReadTime(e.target.value)}
              placeholder="Enter estimated read time"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Tags (comma separated)</label>
            <input
              type="text"
              className="form-control"
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="Enter tags separated by commas"
            />
          </div>

          <div className="d-flex gap-2">
            <button type="submit" className="btn btn-success">
              Save Post
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </div>
  );
}
